import React, { useState, useRef, useEffect } from "react"
import classNames from "classnames"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons/faPhoneAlt"
import "./PhoneFab.scss"

const PhoneFAB = ({ phones }) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef(null)

  const mainClasses = classNames("phone-fab", {
    open: isOpen
  })

  const handleClickOutside = event => {
    if (isOpen) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", handleClickOutside, true)
    } else {
      document.removeEventListener("click", handleClickOutside, true)
    }
    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [isOpen])

  const handleClick = () => setIsOpen(!isOpen)
  return (
    <div className={mainClasses} ref={containerRef}>
      <div className="phone-fab__phone">
        <div className="phone-fab__heading">
          <p>Contact Us</p> <div className="fab__hline" />
        </div>

        <p className="phone-fab__subtext">Text Preferred</p>

        <div className="phone-fab__phones-container">
          {phones.map(item => (
            <div key={item.name} className="phone-fab__single-phone">
              <h5>{item.name}</h5>
              <p>
                <a
                  aria-label="Call phone number"
                  href={`tel:${item.href}`}
                  title={item.altTitle}>
                  {item.phone}
                </a>
              </p>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        aria-label="open phone list"
        className="phone-fab__button"
        onClick={handleClick}>
        <FontAwesomeIcon icon={faPhoneAlt} />
      </button>
    </div>
  )
}

export default PhoneFAB
